import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import "../Patient/list.scss"
import Myprofile from "./myprofile"

const MyProfileContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
        <Myprofile />
        </>
      </div>
    </div>
  )
}

export default MyProfileContainer